import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { DeviceLatestStatus } from 'app/models/device-latest-status.model';
import { Device } from 'app/models/device.model';
import { DeviceAllRequest } from 'app/models/deviceAllRequest.model';
import { DeviceRequestService } from 'app/services/device-request.service';
import { DeviceService } from 'app/services/device.service';
import { ExcelService } from 'app/services/excel.service';
import * as L from 'leaflet';
import 'leaflet-draw';
import { ApexAxisChartSeries, ApexChart, ApexDataLabels, ApexGrid, ApexStroke, ApexTheme, ApexTitleSubtitle, ApexTooltip, ApexXAxis, ApexYAxis, ChartComponent } from 'ng-apexcharts';
import { NgxSpinnerService } from 'ngx-spinner';

export type ChartOptions = {
    series: ApexAxisChartSeries;
    chart: ApexChart;
    xaxis: ApexXAxis;
    yaxis: ApexYAxis;
    tooltip: ApexTooltip;
    theme:ApexTheme;
    colors:string[];
    labels:string[];
    fill:any
    dataLabels: ApexDataLabels;
    grid: ApexGrid;
    stroke: ApexStroke;
    title: ApexTitleSubtitle;
  };
  


const iconUrl = 'assets/img/marker-icon.png';
const iconDefault = L.icon({
    iconUrl,
    iconSize: [30, 30],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28]
});

L.Marker.prototype.options.icon = iconDefault;


@Component({
    selector: 'device-view',
    templateUrl: './device-view.component.html',
    styleUrls: ['./device-view.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    providers: [ExcelService]
})
export class DeviceViewComponent implements OnInit {
    @ViewChild("msfChart") msfChart: ChartComponent;
    public msfChartOptions: Partial<ChartOptions>;
    @ViewChild("heatChart") heatChart: ChartComponent;
    public heatChartOptions: Partial<ChartOptions>;
    @ViewChild("batChart") batChart: ChartComponent;
    public batChartOptions: Partial<ChartOptions>;

    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;

    capitals: string = '/assets/data/usa-capitals.geojson';

    public deviceId;
    public sortActive=null;
    public sortDirection=null;
    public pageLenght:number;
    public device:Device; 
    public startDate = new Date(new Date().setDate(new Date().getDate() - 7));
    public endDate = new Date();
    private _duration: string;
    public get duration(): string {
        return this._duration;
    }

    private _dataSource: MatTableDataSource<DeviceAllRequest> = undefined;
    public get dataSource(): MatTableDataSource<DeviceAllRequest> {
        return this._dataSource;
    }
    private _requestAllList: Array<DeviceAllRequest> = [];
    public get requestAllList() {
        return this._requestAllList;
    }
    
    private _requestStatsList: Array<DeviceAllRequest> = [];
    public get requestStatsList(): Array<DeviceAllRequest> {
        return this._requestStatsList;
    }


    private _requestList: DeviceLatestStatus;   // düzenle 

    public get requestList(): DeviceLatestStatus {
        return this._requestList;
    }

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }
    private _displayedColumns = ['frm', 'gpS_Enlem', 'gpS_Boylam', 'gpS_Fix', 'gpS_Uydu_Sayisi', 'gpS_Dinleme_Sayisi', 'gpS_Rakim', 'slr', "bat", "sck", "msf","alarmType", "date"];
    
        constructor(
        private deviceRequest: DeviceRequestService,
        private _spinner:NgxSpinnerService,
        private _excelService:ExcelService,
        private datePipe:DatePipe,
        private route: ActivatedRoute,
        private _deviceService:DeviceService) 
        {
            this.msfChartOptions = {
                series: [
                  {
                    name: "Mesafe",
                    data: [0,0]
                  }
                ],
                chart: {
                  height: 350,
                  type: "line",
                  zoom: {
                    enabled: false
                  }
                },
                 theme: {
                     mode: 'dark', 
                     palette: 'palette1', 
                     monochrome: {
                         enabled: false,
                         color: '#255aee',
                         shadeTo: 'dark',
                         shadeIntensity: 0.65
                     },
                 },
                dataLabels: {
                  enabled: false
                },
                stroke: {
                  curve: "straight"
                },
                title: {
                  text: "Cihaz Mesafe Ölçümü",
                  align: "left"
                },
                xaxis: {
                type: 'category',
                  categories: []
                }
              };
            this.batChartOptions = {
                series: [{
                    name: 'Batarya Durumu',
                    data: [0]
                  }, {
                    name: 'Solar Batarya Durumu',
                    data: [0]
                }],
                chart: {
                  height: 350,
                  type: "area",
                  zoom: {
                    enabled: false
                  }
                },
                 theme: {
                     mode: 'dark', 
                     palette: 'palette1', 
                     monochrome: {
                         enabled: false,
                         color: '#255aee',
                         shadeTo: 'dark',
                         shadeIntensity: 0.65
                     },
                 },
                dataLabels: {
                  enabled: false
                },
                stroke: {
                  curve: "straight"
                },
                title: {
                  text: "Cihaz Batarya Durumu",
                  align: "left"
                },
                xaxis: {
                type: 'category',
                  categories: []
                }
              };

            this.heatChartOptions = {
                series: [{
                    name: 'CPU Sıcaklığı',
                    data: [0]
                  }],
                chart: {
                  height: 350,
                  type: "area",
                  zoom: {
                    enabled: false
                  }
                },
                 theme: {
                     mode: 'dark', 
                     palette: 'palette1', 
                     monochrome: {
                         enabled: false,
                         color: '#255aee',
                         shadeTo: 'dark',
                         shadeIntensity: 0.65
                     },
                 },
                dataLabels: {
                  enabled: false
                },
                stroke: {
                  curve: "straight"
                },
                title: {
                  text: "Cihaz Sıcaklık Durumu",
                  align: "left"
                },
                xaxis: {
                type: 'category',
                  categories: []
                }
              };
        }

    public get MapTileUrl(): string {
        return 'http://tile.openstreetmap.org/{z}/{x}/{y}.png';
    }

    async ngOnInit(): Promise<void> {
        await this.getDevice();
        await this.pageCount();
        await this.getAllRequestList();
        await this.getByDateBetweenRequests();
    }

    private async getDevice(){
        this.route.queryParamMap.subscribe(params => {

            this.deviceId = params['params']['deviceId']
        });
        try {
            this.device = await this._deviceService.getByDevice(this.deviceId);
            this._requestList= this.device.deviceLatestStatus
        } catch (error) {
            this._spinner.hide('loading');
            console.warn(error);
        }
    }

    public async onReportRateClick() {
         const columns = [
            "No", 
            "Cihaz id",
            "Firmware", 
            "Gps Enlem", 
            "Gps BoylaM", 
            "Gps Fix", 
            'Gps Uydu Sayısı', 
            "Gps Dinleme Sayısı",
            "Gps Rakım",
            "Solar Voltaj",
            "Batarya",
            "Cpu Sıcaklık",
            "Doluluk",
            "Tarih",
        ];
         let idx = 1;
         const dataset = this._requestAllList.map(p => {
             return {
                 index: idx++,
                 cihazId: `${this.deviceId}`,
                 frm: `${p.firmware}`,
                 gpS_Enlem: `${p.gpS_Enlem}`,
                 gpS_Boylam: `${p.gpS_Boylam}`,
                 gpS_Fix: `${p.gpS_Fix}`,
                 gpS_UyduSayisi: `${p.gpS_UyduSayisi}`,
                 gpS_DinlemeSayisi: `${p.gpS_DinlemeSayisi}`,
                 gpS_Rakim: `${p.gpS_Rakim}`,
                 solarEnerjiVoltaj: `${p.solarEnerjiVoltaj}`,
                 batarya: `${p.batarya}`,
                 cpuSicaklik: `${p.cpuSicaklik}`,
                 mesafe: `${p.mesafe}`,
                 date: `${this.datePipe.transform(p.sonBaglantiTarih,'dd.MM.yyyy HH:mm:ss')}`

             }
         });
         this._excelService.exportAsExcelFile(
             columns,
             dataset,
             'Cihaz Ölçüm Logu',
             "",
             new Date(),
             {
                 worksheetName: this.deviceId
             }
         );
    }


    public async getAllRequestList():Promise<DeviceLatestStatus>{
        try {
            this._spinner.show('loading');
            this._requestAllList = await this.deviceRequest.getRequestAllPaginated(
                this.deviceId,
                this._paginator!.pageIndex,
                this._paginator!.pageSize,
                this.sortActive,
                this.sortDirection);
                
            this._requestAllList = this._requestAllList.filter(x=>x.mesafe !="0" && x.mesafe !="4000")

                await this.updateTableDataSource();

                this.dataSource.sortingDataAccessor = (item, property) => {
                    switch (property) {
                       case 'frm' : return item.firmware;
                       case 'gpS_Enlem' : return item.gpS_Enlem;
                       case 'gpS_Boylam' : return item.gpS_Boylam;
                       case 'gpS_Fix' : return item.gpS_Fix;
                       case 'gpS_Uydu_Sayisi' : return item.gpS_UyduSayisi;
                       case 'gpS_Dinleme_Sayisi' : return item.gpS_DinlemeSayisi;
                       case 'gpS_Rakim' : return item.gpS_Rakim;
                       case 'slr' : return item.solarEnerjiVoltaj;
                       case 'bat' : return item.batarya;
                       case 'sck' : return item.cpuSicaklik;
                       case 'gsq' : return item.gpS_UyduSayisi;
                       case 'ack' : return item.acikKalmaSuresi;
                       case 'ags' : return item.gsM_BaglantiSuresi;
                       case 'msf' : return item.mesafe;
                       case 'dbG0' : return item.yetersizBataryaUyanamamaCount;
                       case 'dbG1' : return item.gsM_SinyaliYakalayamamaCount;
                       case 'dbG2' : return item.gpS_VerisiFixleyememeCount;
                       case 'dbG3' : return item.sunucuHaberlesememeCount;
                       case 'dbG4' : return item.maxUyaniklikSuresiAsmaCount;
                       case 'date' : return item.sonBaglantiTarih;
                      default: return item[property];
                 }
                }

            this._spinner.hide('loading');
        } catch (error) {
            this._spinner.hide('loading');
            console.warn(error);
            return;
        }
    }

    public async pageCount(){
        try {            
            this.pageLenght = await this.deviceRequest.getRequestCount(this.deviceId);
        } catch (error) {
            this._spinner.hide('loading');
            console.warn(error);
        }
    }

    public async pageEvent(e) {
        try {
            this._spinner.show('loading');
            this._requestAllList = await this.deviceRequest.getRequestAllPaginated(this.deviceId,this._paginator.pageIndex,this._paginator.pageSize,this.sortActive,this.sortDirection);
           this._requestAllList = this._requestAllList.filter(x=>x.mesafe !="0" && x.mesafe !="4000")
            this._spinner.hide('loading');
        } catch (error) {
            this._spinner.hide('loading');
            console.warn(error);
            return [];
        }
        this.updateTableDataSource();        
    }

    public async sortData(e){
        try {
            if(e.direction==""){
                this.sortDirection = null;
                this.sortActive = null;
            }
            else{
                this.sortActive = e.active;
                this.sortDirection = e.direction;
            }
            this._spinner.show('loading');   
            this._requestAllList = await this.deviceRequest.getRequestAllPaginated(this.deviceId,this._paginator.pageIndex,this._paginator.pageSize,this.sortActive,this.sortDirection);
            this._requestAllList = this._requestAllList.filter(x=>x.mesafe !="0" && x.mesafe !="4000")
            this._spinner.hide('loading');
        } catch (error) {
            this._spinner.hide('loading');
            console.warn(error);
            return [];
        }
        this.updateTableDataSource();
    }


    HeatData() {
        var heat = []
        var label = []
        this._requestStatsList.forEach(element => {
            heat.push(parseInt(element.cpuSicaklik)/10)
            label.push(this.datePipe.transform(element.sonBaglantiTarih,'dd MMMM yyyy HH:mm'));
        })

        this.heatChartOptions = {
            series: [{
                name: 'CPU Sıcaklığı',
                data: heat
              }],
            chart: {
              height: 350,
              type: "area",
              zoom:{
                type:"x",
                enabled:true,
                autoScaleYaxis:true
              },
               toolbar: {
                autoSelected: "zoom"
            }
            },
             theme: {
                 mode: 'dark', 
                 palette: 'palette1', 
                 monochrome: {
                     enabled: false,
                     color: '#255aee',
                     shadeTo: 'dark',
                     shadeIntensity: 0.65
                 },
             },
             tooltip:{
                enabled:true,
                x: {
                    show: true,
                    format: 'dd.MM.yyyy HH:mm',
                    formatter: undefined,
                },
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: "straight"
            },
            title: {
              text: "Cihaz Sıcaklık Durumu",
              align: "left"
            },
            labels:label,
            xaxis: {
                type:'datetime',
                labels:{
                    datetimeUTC:false,
                  datetimeFormatter: {
                      year: 'yyyy',
                      month: "dd/MM/yy",
                      day: 'dd/MM/yy',
                      hour: 'HH:mm',
                  },
                }
            },
            yaxis: {
                labels: {
                  offsetX: 10
                }
              },
              grid: {
                show:true,
                padding: {
                  left: 30,
                  right: 30,
                }
              }
          };
    }

    BatData() {
        var Label = []
        var datasolar = []
        var databat = []
        this._requestStatsList.forEach(element => {
            datasolar.push(parseInt(element.solarEnerjiVoltaj) / 100)
            databat.push(parseInt(element.batarya) / 100)
            Label.push(this.datePipe.transform(element.sonBaglantiTarih,'dd MMMM yyyy HH:mm'));
        });

        this.batChartOptions = {
            series: [{
                name: 'Batarya Durumu',
                data: databat
              }, {
                name: 'Solar Batarya Durumu',
                data: datasolar
            }],
            chart: {
              height: 350,
              type: "area",
              zoom:{
                type:"x",
                enabled:true,
                autoScaleYaxis:true
              },
               toolbar: {
                autoSelected: "zoom"
            }
            },
             theme: {
                 mode: 'dark', 
                 palette: 'palette1', 
                 monochrome: {
                     enabled: false,
                     color: '#255aee',
                     shadeTo: 'dark',
                     shadeIntensity: 0.65
                 },
             },
            dataLabels: {
              enabled: false
            },
            labels:Label,
            tooltip:{
                enabled:true,
                x: {
                    show: true,
                    format: 'dd.MM.yyyy HH:mm',
                    formatter: undefined,
                },
            },
            stroke: {
              curve: "straight"
            },
            title: {
              text: "Cihaz Batarya Durumu",
              align: "left"
            },
            xaxis: {
                type:'datetime',
                labels:{
                    datetimeUTC:false,
                  datetimeFormatter: {
                      year: 'yyyy',
                      month: "dd/MM/yy",
                      day: 'dd/MM/yy',
                      hour: 'HH:mm',
                  },
                }
            },
            yaxis: {
                labels: {
                  offsetX: 10
                }
              },
              grid: {
                show:true,
                padding: {
                  left: 30,
                  right: 30,
                }
              }
          };

    }

    MsfData(){
        var data = []
        var label = [];
        this._requestStatsList.forEach(element => {
            data.push(element.mesafe);
            label.push(this.datePipe.transform(element.sonBaglantiTarih,'dd MMMM yyyy HH:mm'));
        });
        this.msfChartOptions = {
            series: [
              {
                name: "Mesafe(mm)",
                data: data
              }
            ],
            chart: {
              height: 350,
              type: "line",
              zoom:{
                type:"x",
                enabled:true,
                autoScaleYaxis:true
              },
               toolbar: {
                autoSelected: "zoom"
            }
            },
            dataLabels: {
              enabled: false,
            },
            tooltip:{
                enabled:true,
                x: {
                    show: true,
                    format: 'dd.MM.yyyy HH:mm',
                    formatter: undefined,
                },
            },
            stroke: {
                show:true
            },
            theme: {
                mode: 'dark', 
                palette: 'palette1', 
                monochrome: {
                    enabled: false,
                    color: '#255aee',
                    shadeTo: 'dark',
                    shadeIntensity: 0.65
                },
            },
            title: {
              text: "Cihaz Mesafe Ölçümü",
              align: "left",
            },
           labels:label,
            xaxis: {
         //     categories: label,
              type:'datetime',
              labels:{
                datetimeUTC:false,
                datetimeFormatter: {
                    year: 'yyyy',
                    month: "dd/MM/yy",
                    day: 'dd/MM/yy',
                    hour: 'HH:mm',
                },
              }
            },
            yaxis: {
                labels: {
                  offsetX: 10,
                }
              },
              grid: {
                show:true,
                padding: {
                  left: 30,
                  right: 30,
                }
              }
          };
    }
    
    public async getByDateBetweenRequests() {
        try {
            this._spinner.show('loading');
            this._requestStatsList = await this.deviceRequest.getByDateBetweenRequests(this.deviceId, this.startDate,this.endDate);
            this._requestStatsList = this._requestStatsList.filter(x=>x.mesafe!="0" && x.mesafe!="4000")
            await this.refreshChart()
            this._spinner.hide('loading');
        } catch (error) {
            this._spinner.hide('loading');
            console.warn(error);
        }
    }

    public async refreshChart(){
        this.BatData();
        this.HeatData();
        this.MsfData();
    }

    private async updateTableDataSource(): Promise<void> {        
        this._dataSource = new MatTableDataSource<DeviceAllRequest>(this._requestAllList);
    }

}
